import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles'
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";

import AccordionCard from './accordion';

let useStyles = makeStyles((theme) => ({
    root: {
        width: '75%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',

        [theme.breakpoints.down('sm')]: {
            width: '100%',
        },
    },
    AppBar: {
        backgroundColor: 'transparent',
        border: 'none',
        color: '#0B1742',
        boxShadow: 'none'
    }
}))



function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`nav-tabpanel-${index}`}
            aria-labelledby={`nav-tab-${index}`}
            {...other}
            style={{ width: '100%' }}
        >
            {value === index && <Box>{children}</Box>}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `nav-tab-${index}`,
        "aria-controls": `nav-tabpanel-${index}`
    };
}

function LinkTab(props) {
    return (
        <Tab
            component="a"
            onClick={(event) => {
                event.preventDefault();
            }}
            {...props}
        />
    );
}



export default function Index() {

    const classes = useStyles();

    const [valueTab, setValueTab] = useState(0);

    const handleChange = (event, newValue) => {
        setValueTab(newValue);
    };

    return (
        <div className={classes['root']}>
            <AppBar position="sticky" className={classes['AppBar']} style={{ zIndex: 0, backgroundColor: 'transparent' }} >
                <Tabs
                    value={valueTab}
                    onChange={handleChange}
                    aria-label="wrapped label tabs"
                    className={classes.appBar}
                    centered
                >
                    <LinkTab
                        className={classes["LinkTab"]}
                        label="سوالات آموزشی"
                        href="/"
                        {...a11yProps(0)}
                    />
                    <LinkTab
                        className={classes["LinkTab"]}
                        label="سوالات بورسی"
                        href="/"
                        {...a11yProps(1)}
                    />
                    <LinkTab
                        className={classes["LinkTab"]}
                        label="بورس کالا"
                        href="/"
                        {...a11yProps(1)}
                    />
                </Tabs>
            </AppBar>
            <TabPanel value={valueTab} index={0}>
                <AccordionCard data={dataQuestionEducational} />
            </TabPanel>
            <TabPanel value={valueTab} index={1}>
                <AccordionCard data={dataQuestionBourse} />
            </TabPanel>
            <TabPanel value={valueTab} index={2}>
                <AccordionCard data={dataKala} />
            </TabPanel>
        </div>

    )
}


let dataQuestionEducational = [
    {
        question: 'نحوه‌ی استفاده از سامانه معاملات بر خط چگونه است؟',
        answer: [
            "در نخستين‌گام براي دسترسي به سامانه معاملات برخط سهام، متقاضي بايد به يکي از شرکت‌هاي کارگزاري بورس در سراسر کشور مراجعه و درخواست خود براي دسترسي به سامانه معاملات برخط را به شرکت مذکور کنـد. يکي از پيش‌شرط‌هاي اساسي که سازمان بورس براي استفاده سرمايه‌گذار از سامانه معاملات برخط (آنلاين) تعيين کرده است، آشنايي کافي سرمايه‌گذار با اصول خريد و فروش اوراق بهادار در بورس، قوانين و مقررات اساسي مرتبط با سرمايه‌گذاري در بورس و نحوه استفاده از سامانه معاملـه برخط است؛ زيرا همان طور که گفته شد، در سامانه معاملات برخط، سرمايه‌گذار خود مستقيماً و بدون واسطه کارگزار، نسبت به خريد و فروش اوراق بهادار در بورس اقدام مي‌کند. بنابراين، لازم است آشنايي کافي با اصول و مقررات مرتبط با سرمايه‌گذاري در بورس را داشتـه باشد. و از دیگر مزایای این سامانه می توان به سرعت عمل در تصميم‌گيري، عدم محدوديت زماني و مکاني براي سرمايه‌گذاري، نقل و انتقال الکترونيک وجوه، کاهش اختلافات بين سرمايه‌گذار و کارگزار و امنيت بالاي سامانه معاملات برخط، اين سامانه با استقبال بسيار زياد سرمايه‌گذاران مواجه شده است.",
        ]
    },
    {
        question: 'چه زمانی نیاز به ثبت درخواست تغییر کارگزار ناظر است؟ ',
        answer: [
            "فرض کنید دو ماه قبل برای اولین بار نماد فولاد را در یک کارگزاری خریداری کرده‌اید (و حتی بلافاصله فروخته‌اید). در حال حاضر کارگزار ناظر شما آن کارگزاری است. در صورتی که امروز هم نماد فولاد را در کارگزاری پویان  خریداری نمایید، در انتهای روز در پرتفوی یا سبدبان شما در کارگزاری قبلی قرار خواهد گرفت. جهت مشاهده دارایی خود در کارگزاری پویان  می‌بایست اقدام به تغییر کارگزار ناظر نمایید."
        ]
    },
    {
        question: 'پذیره نویسی چیست؟ ',
        answer: [
            `
پذیره‌نویسی در لغت به معنای "نوشتن و امضاکردن در سند و نوشته" می‌باشد و در واقع به تعهد انجام کار یا تعهد امری که در سند به آن ذکر شده است، اشاره دارد. احتمالاً در بازار بورس نیز اصطلاح پذیره‌نویسی را شنیده‌اید؛ پذیره‌نویسی در بازارهای مالی به معنی فرایند خرید اوراق بهادار از ناشر و یا نماینده قانونی و پرداخت تعهد وجه کامل، طبق قرارداد است. یکی از موارد مهم در این اصطلاح، تعهد و تسهیل تأمین مالی می‌باشد؛ بهتر است بدانیم که فرایند پذیره‌نویسی، تأمین مالی را در شرکت‌ها بهتر و آسان‌تر کرده است   .`
        ]
    },
    {
        question: 'کارگزار ناظر چیست؟',
        answer: [
            "پس از خریداری سهم، اطلاعات سهام خریداری‌شده باید در اختیار یک کارگزار قرار گیرد. این کارگزار به‌اصطلاح «کارگزار ناظر» نامیده می‌شود."
        ]
    },
    {
        question: 'شرایط دریافت اعتبار چیست؟ ',
        answer: [
            "دریافت اعتبار از هر کارگزاری با توجه به شرایط تعیین شده توسط همان کارگزاری و طبق روال مشخص شده برای آن، امکان‌پذیر است. اما در حالت کلی، کارگزاران به مشتریان فعال‌تر خود اعتبار پرداخت می‌کنند. علاوه بر این، پرتفوی شخص متقاضی دریافت اعتبار نیز از نظر ارزش دارایی و تنوع، باید شرایط به‌خصوصی داشته باشد. "
        ]
    },
    {
        question: 'اعتبار چیست؟',
        answer: [
            "اعتبار معاملاتی در بازار سرمایه در واقع وامی است که از طرف کارگزاران در اختیار معامله‌گران و سرمایه‌گذاران قرار می‌گیرد. ضوابط و دستورالعمل‌های مربوط به اعتبار معاملاتی توسط سازمان بورس و اوراق بهادار تهران تعیین می‌شود. علاوه بر آن، هر یک از کارگزاران فعال در بازار سرمایه نیز تحت شرایط خاصی به کاربران خود اعتبار پرداخت می‌کنند."
        ]
    },
    {
        question: 'به چه دلایلی ممکن است درخواست تغییر کارگزار ناظر با خطا مواجه شود؟ ',
        answer: [
            "عدم دارایی در نماد مورد نظر، فریز بودن سهم، بدهکاری"
        ]
    },
    {
        question: 'قیمت روز یا قیمت بازاری سهام یعنی چه؟ ',
        answer: [
            "قیمت روز یا قیمت بازاری به قیمت خرید و فروش یک سهم در بازار اشاره دارد. یعنی همان رقمی که امروز برای خرید یک سهم خاص باید بپردازید. این رقم لزوما با ارزش ذاتی سهام برابر نیست و ممکن است بیشتر یا کمتر از آن باشد. میزان عرضه و تقاضا، اوضاع سیاسی و اقتصادی کشور و جهان، هیجانات سرمایه‌گذاران و … روی قیمت روز سهام تاثیر می‌گذارند."
        ]
    },
    {
        question: 'عرضه اولیه چیست؟ ',
        answer: [
            "زمانی که یک شرکت برای اولین بار سهام خود را در بازار ارائه می‌کند، عرضه اولیه صورت گرفته است. پس از تعیین قیمت، سهام به میزان مشخصی وارد بازار می‌شود و طبق تجربه قیمت آن تا چندین درصد افزایش پیدا خواهد کرد. به دلیل احتمال کسب سود بالا، مردم تمایل زیادی نسبت به خرید عرضه اولیه دارند و جو خوش‌بینانه‌ای در این زمینه حاکم است."
        ]
    },
]

let dataQuestionBourse = [
    {
        question: "وجه حاصل از فروش سهام چه زمانی قابل وصول است؟ ",
        answer: [
            'وجه حاصل از فروش سهام، دو روز کاری پس از انجام معامله قابل دریافت است. روزهای کاری، ایام هفته به جز روزهای پنج شنبه و تعطیلات رسمی می باشد.'
        ]
    },
    {
        question: "کارمزد معاملات سهام و حق تقدم سهام در بورس چه میزان میباشد؟ ",
        answer: [
            `
            زمانی‌که  در بورس اوراق بهادار معامله‌ای صورت می‌گیرد، بخشی از ارزش معامله را کارمزد تشکیل می‌دهد که به آن کارمزد بورس یا کارمزد معاملات بورس می‌گویند.
            
            بر اساس مصوبه هیأت مدیره سازمان بورس و اوراق بهادار درحال حاضر سقف کارمزد کارگزاران در معاملات سهامی که ارزش معامله آنها 5 میلیون ریال یا کمتر باشد، بیست هزار ریال تعیین گردیده است. کارمزد خرید و فروش جمعا0.012512 میباشد که به تفکیک کارمزد خرید 0.003712وکارمزد فروش0.0088 میباشد این کارمزد در واقع هزینه خدماتی است که سازمان‌ها و نهادهای مختلف ارائه می‌کنند تا امکان معامله بین خریداران و فروشندگان به وجود بیاید. برای اطلاع دقیق از نرخ کارمزد و خدمات معاملات انواع اوراق بهادار در بورس، بهترین روش ممکن مراجعه به سایت سازمان بورس است. در سایت اینترنتی این سازمان، به‌راحتی می‌توانید فایل مربوط به کارمزدها را دانلود ومشاهده نمایید.
            `
        ]
    },
    {
        question: "دامنه نوسان بورس چیست؟ دامنه نوسانات قیمت سهام چقدر است؟ ",
        answer: [
            'طبق آیین‌نامه معاملات در شرکت بورس تهران، دامنه نوسان قیمت، پایین‌ترین تا بالاترین قیمتی است که در آن دامنه طی یک یا چند جلسه رسمی معاملات بورس، قیمت می‌تواند نوسان کند.',
            'نوسان قیمت سهام، اوراق بدهی و اوراق مشتقه در بازار دوم بورس و فرابورس حداکثر ٪۵ و حداقل ٪۵- است. در بازار اول بورس و فرابورس این نوسانات می‌تواند حداکثر تا ٪ ۷ تغییر کند.',
            'دامنه نوسانِ حق تقدم سهام، دو برابر دامنه نوسان سهام عادی است؛ لذا برای بازار اول بورس و فرابورس، معادل ۱۴٪ و برای بازار دوم بورس و فرابورس معادل ٪۱۰ است.',
            'دامنه نوسان در صندوق‌ سرمایه‌گذاری قابل معامله (ETF)، معادل ٪۱۰ است.',
            'دامنه نوسان سهام شرکت‌ها در بازار پایه فرابورس تا قبل از تاریخ مهر ماه ۱۳۹۸، معادل ٪۱۰ بود اما پس از این تاریخ، دامنه نوسان این بازار به شرح زیر تغییر کرد :',
            'دامنه نوسان بازار پایه زرد : مثبت منفی سه درصد نسبت به قیمت پایانی روز قبل',
            'دامنه نوسان بازار پایه نارنجی : مثبت منفی دو درصد نسبت به قیمت پایانی روز قبل',
            'دامنه نوسان بازار پایه قرمز : مثبت منفی یک درصد نسبت به قیمت پایانی روز قبل',
        ]
    },
    {
        question: "شرکت ها چگونه زمان و دستور جلسات مجامع عمومی خود را اعلام می کنند؟ ",
        answer: [
            'شرکت ها موظف هستند که زمان، تاریخ، محل تشکیل و دستور جلسه مجامع عمومی را در روزنامه های کثیر الانتشار و سایت اینترنتی خود درج کرده و مراتب را حداقل 10 روز قبل از برگزاری مجمع افشا نمایند.'
        ]
    },
    {
        question: "حداقل و حداکثر فاصله بین نشر دعوتنامه مجمع عمومی و تاریخ تشکیل آن چند روز است؟",
        answer: [
            'حداقل 10 روز و حداکثر 40 روز'
        ]
    },
    {
        question: "به طور کلی چند نوع اوراق مشارکت در ایران منتشر می شود؟ ",
        answer: [
            'به طور کلی چند نوع اوراق مشارکت در ایران منتشر می شود؟ ',
            'الف-اوراق مشارکت بانک مرکزی',
            'ب-اوراق مشارکت وزارت خانه ها و شرکت های دولتی',
            'ج-اوراق مشارکت شرکت های پذیرش شده در بورس',
        ]
    },
    {
        question: "آیا افراد حقیقی می توانند در بورس کالا خرید و فروش نمایند؟",
        answer: [
            'آری، همانند بورس اوراق بهادار افراد حقیقی می توانند با گرفتن کد معاملاتی از کارگزاری ها اقدام به خرید و فروش در بورس کالا کنند.',
        ]
    },
    {
        question: "سود شرکت ها چه زمانی پرداخت می شود؟ ",
        answer: [
            'طبق قانون تجارت، در صورتی که در مجمع عمومی عادی سالیانه، تقسیم سود تصویب شود، شرکت باید حداکثر ظرف 8 ماه از تاریخ تصویب،DPS را به سهامداران پرداخت کند.',
        ]
    },
    {
        question: "آیا مدل سرمایه گذاری وجود دارد که در آن ریسک کمتری داشته باشد؟ ",
        answer: [
            'با توجه به مدت سرمایه گذاری و نوع ریسک پذیری شما روش های مختلف سرمایه گذاری وجود دارد؛ کم ریسک ترین نوع سرمایه‌گذاری صندوق های با درآمد ثابت است که ترکیب دارایی آن ها را با انواع اوراق تشکیل می دهد، برای سرمایه گذاری در صندوق‌های سرمایه گذری مشترک هر چه نگاه بلند مدت تر باشد نوسانات کمتر خواهد شد.',
        ]
    },
    {
        question: "برای سرمایه‌گذاری در بورس چه مبلغی لازم می باشد؟ ",
        answer: [
            'حداقل سرمایه‌ای که می‌توانید با آن وارد بورس شوید ۵۰۰ هزار تومان می باشد. سود و زیانی که با آن مواجه می‌شوید به صورت درصدی محاسبه خواهد شد. طبیعتا هر چه سرمایه بیشتری وارد بورس کنید، میزان سود یا زیان‌تان نیز بیشتر می‌شود.'
        ]
    },
    {
        question: "حجم مبنا چیست؟ ",
        answer: [
            'حجم مبنـا به حداقل تعداد سهام یک شرکت گفته می شود که باید در طول روز، معامله شود تا قیمت آن سهم، بتوانـد براساس سقف دامنه نوسان، افزایش یا کاهش یابد.'
        ]
    },

]

let dataKala=[
    {
        question: "حساب وکالتی بورس کالا چیست؟",
        answer: [
            "حساب وکالتی نزد بانک مورد نظر به حساب معاملاتی مشتریانی که قصد خرید کالا در بورس کالا را داشته باشند وصل میشود. از طریق این حساب به کارگزاری وکالت داده می‌شود تا وجه مورد نیاز سفارش‌های خرید در بورس کالا را مستقیما در حساب بانکی مشتری و با اجازه مشتری مسدود کند.",
        ]
    },
    {
        question: "کدام بانک‌ها امکان افتتاح حساب وکالتی را دارند؟",
        answer: [
            "درحال حاضر امکان افتتاح حساب وکالتی برعهده بانک‌های ملت، پاسارگاد، صنعت و معدن، توسعه صادرات، سپه، آینده، اقتصاد نوین، کشاورزی، صادرات ایران، شهر، سینا، سامان، ملی ایران، رفاه کارگران، تجارت، توسعه تعاون، گردشگری و پارسیان است.",
        ]
    },
    {
        question: "آیا حساب وکالتی برای معاملات آتی برای معاملات بورس کالا کافی است؟",
        answer: [
            "برای معاملات آتی باید حساب در اختیار معرفی شود که با حساب وکالتی متفاوت است. حساب در اختیار باید در بانکی افتتاح شود که شخص حساب عادی دیگری نیز در آن بانک داشته باشد تا حساب در اختیار فرد به آن متصل شود بنابراین باید به بخش اعلام شماره حساب وکالتی و در اختیار در سامانه ایبیگو مراجعه و بانک‌های موجود را بررسی و فرم مربوط به آن را دریافت شود. بعد از افتتاح حساب وکالتی مجدد وارد سامانه ایبیگو شده و از قسمت اعلام شماره حساب وکالتی و در اختیار، حساب خود را معرفی کند.",
        ]
    },
    {
        question: "افرادی که کد بورسی دارند هم باید برای ثبت نام در بورس کالا دوباره سجام و کد بورسی بگیرند؟",
        answer: [
            "برای خرید خودرو از بورس کالا، داشتن کد بورسی کافی نیست و باید کد معاملاتی بازار فیزیکی بورس کالا دریافت شود. لازم به ذکر است، در صورت تکمیل روند ثبت‌نام و احرازهویت در سامانه سجام، نیازی به ثبت‌نام مجدد نیست.",
        ]
    },
    {
        question: "تعیین قیمت نهایی خودرو در بورس کالا چگونه است؟",
        answer: [
            "قیمت‌گذاری (قیمت پایه) توسط شورای رقابت و با درنظر گرفتن قیمت تمام شده تولید خودرو، مالیات و …. تعیین می‌گردد و قیمت نهایی (معامله شده در بورس کالا) خودرو براساس میزان تقاضا و همچنین قیمت ثبت‌شده از جانب سرمایه‌گذاران تعیین می‌شود.",
        ]
    },
    {
        question: "کشف قیمت در بورس کالا به چه صورت انجام میگیرد؟",
        answer: [
            "در صورتی که تعداد عرضه از تقاضا بیش‌تر باشد، معاملات با قیمت پایه انجام خواهد شد. چنانچه تعداد تقاضا از حجم کالای عرضه‌شده بیش‌تر شود، معاملات به‌صورت مزایده انجام می‌پذیرد. لذا سفارشات ارسال شده با قیمت بالاتر در اولویت قرار خواهند گرفت. و در صورت ارسال قیمت مساوی، قیمتی که به لحاظ زمانی زودتر ارسال گردد در اولویت خواهد بود.",
        ]
    },
    {
        question: "هر فرد چه تعداد خودرو می‌تواند بخرد؟",
        answer: [
            "در حال حاضر برای خرید خودرو هر کد ملی تنها امکان ثبت سفارش روی یکی از خودروهای موجود و به تعداد یک عدد را دارد. به عبارت دیگر اگر شخصی در عرضه‌های قبلی موفق به خرید خودروی سواری شده‌ باشد امکان ثبت سفارش نخواهد داشت.",
        ]
    },
]